import { isNil, isObject } from 'lodash-es';
import { CheckType } from 'common/constants';
import { formatSize } from './utils';

export const formatCheckResult = (type, result, nullMessage = '‘未找到质检结果’') => {
  // 前端显示dcc返回的Check前作数据书面化处理
  if (isNil(result) || result?.length === 0) {
    return nullMessage;
  }
  switch (type) {
    case CheckType.Resolution:
      const format = isObject(result) ? result : JSON.parse(result);
      return `${format?.x}*${format?.y}`;
    case CheckType.FileSize:
      return formatSize(result);
    case CheckType.FrameRate:
    case CheckType.TotalFrames:
      if (typeof result === 'number') {
        return result.toFixed(2);
      } else {
        return result;
      }
    case CheckType.ImagePlagiarism:
      return `<a href="${result.link}" target="_blank">${result.percentage}(查看详情)</a>`;
    default:
      if (result && typeof result === 'string') {
        return result;
      } else if (Array.isArray(result)) {
        return result.map(r => r);
      }
      return JSON.stringify(result);
  }
};
export const formatCheckValue = (type, value, nullMessage = '‘未找到目标值’') => {
  if (isNil(value) || value?.length === 0) {
    return nullMessage;
  }
  switch (type) {
    case CheckType.Resolution:
      const format = isObject(value) ? value : JSON.parse(value);
      return `${format?.x}*${format?.y}`;
    case CheckType.FileSize:
      return formatSize(value);
    case CheckType.FrameRate:
    case CheckType.TotalFrames:
      if (typeof value === 'number') {
        return value.toFixed(2);
      } else {
        return value;
      }

    default:
      if (value && typeof value === 'string') {
        return value;
      } else if (Array.isArray(value)) {
        return value.map(r => r);
      }
      return JSON.stringify(value);
  }
};
